var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "d-flex justify-content-end p-05 " + _vm.displayStatus,
      staticStyle: { width: "100%" },
    },
    [
      _c("div", { staticClass: "pr-05" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success waves-effect waves-light white",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.acceptInvite()
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-sign-in-alt" }),
            _vm._v(" Accept Invite\n        "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pr-05" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-danger waves-effect waves-light white",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.rejectInvite()
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-times" }),
            _vm._v(" Reject Invite\n        "),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }